import React, { useEffect } from 'react';

import { API_URL, TENANT_CODE } from '~/env';
import { useTenant } from '~/hooks/tenant';
import { exchangeCodeToTokens } from '~/api/auth';
import { useLoggedUser } from '~/hooks/user';

const AuthRedirectHandler = ({ code }: { code: string }) => {
  useEffect(() => {
    exchangeCodeToTokens(code)
      .then((response) => {
        const data = response.data;
        console.log(data);

        const token = data.accessToken;
        const refreshToken = data.refreshToken;
        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', refreshToken);
        console.log('going to root');
        window.location.href = '/';
      })
      .catch((error) => {
        console.log(error);
      });
  }, [code]);
  return null;
};

const DefaultHandler = (props: any) => {
  const { children } = props;

  console.log('default handler');

  const currentUserQuery = useLoggedUser({
    onError() {
      console.log('onError; failed to get user, navigating to login page');
      gotToLoginScreen();
    },
    onSuccess(response) {
      console.log('onSuccess; current user is loaded');
      localStorage.setItem('role', JSON.stringify(response.role));
      localStorage.setItem('identity', JSON.stringify(response.identity));
      localStorage.setItem('justLoggedIn', 'true');
      /*
      // need to wrap history.push() in setTimeout() to avoid staying on same page
      setTimeout(async () => {
        closeLoginNotification();
        await queryClient.fetchQuery(tenantQueryKey);
        history.push('/');
      }, 10);
       */
      /*
      // Current path is /login
      const currentPath = window.location.pathname;
      if (currentPath.includes('/login')) {
        history.push('/'); // Redirect to Dashboard if token is valid
      }
       */
    },
  });
  const requiredHeadersReceived = currentUserQuery.isSuccess;
  const tenantQuery = useTenant({
    enabled: requiredHeadersReceived,
    onSuccess() {
      removePreloader();
    },
    onError() {
      gotToLoginScreen();
    },
  });

  const loading = currentUserQuery.isLoading || tenantQuery.isLoading;

  return loading || !requiredHeadersReceived ? null : children;
};

const Preloader = (props: any) => {
  const { children } = props;

  // check if current path is redirect from KeyCloak
  const currentPath = window.location.pathname;

  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');

  if (currentPath.includes('/auth/redirect') && code) {
    console.log('we are redirected back from KeyCloak; exchanging code to tokens');

    // history.push('/'); // Redirect to Dashboard if token is valid
    return <AuthRedirectHandler code={code} />;
  } else {
    return <DefaultHandler children={children} />;
  }
};

const removePreloader = () => {
  const ele = document.getElementById('ipl-progress-indicator');
  if (ele) {
    // fade out
    ele.classList.add('available');
    setTimeout(() => {
      // remove from DOM
      ele.outerHTML = '';
    }, 500);
  }
};

const gotToLoginScreen = () => {
  const tenantParam = TENANT_CODE ? `&tenant=${TENANT_CODE}` : '';
  window.location.href = `${API_URL}/auth/login?referrer_uri=${window.location.origin}/auth/redirect${tenantParam}`;
  // localStorage.removeItem('token');
  // history.replace('/login');
  // removePreloader();
};

export default Preloader;
